import request from 'superagent-bluebird-promise';

export default request;



// WEBPACK FOOTER //
// ./app/lib/api/request.js